<template>
  <div class="ems-table-header" id="dt-header">
    <div class="ems-header-col"
          :style="{ width: columnWidth.sentDate.size  ? (columnWidth.sentDate.size + 'px') : '13%' }"
          id="sentDate">
      <div class="header-container">
        <div class="crop">
          <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('sentDate', $event)"></div>
          <div class="content no-select label-text-2 padding-left-40px" @click="setSortOption('time')">
            SENT DATE
            <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'time'"></Icon>
            <Icon name="sort-up" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'time' && this.pagingObj.sortReverse"></Icon>
            <Icon name="sort-down" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'time' && !this.pagingObj.sortReverse"></Icon>
          </div>
        </div>
      </div>
    </div>
    <div class="ems-header-col"
          :style="{ width: columnWidth.emailTemplate.size  ? (columnWidth.emailTemplate.size + 'px') : '17%' }"
          id="emailTemplate">
      <div class="header-container">
        <div class="crop">
          <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('emailTemplate', $event)"></div>
          <div class="content no-select label-text-2" @click="setSortOption('template')">
            EMAIL TEMPLATE
            <span>
            <Icon name="sort" class="sort-icon"
                  v-if="this.pagingObj.sortType != 'template'"></Icon>
            <Icon name="sort-up" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'template' && this.pagingObj.sortReverse"></Icon>
            <Icon name="sort-down" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'template' && !this.pagingObj.sortReverse"></Icon>
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="ems-header-col"
          :style="{ width: columnWidth.relatedEvent.size  ? (columnWidth.relatedEvent.size + 'px') : '28%' }"
          id="relatedEvent">
      <div class="header-container">
        <div class="crop">
          <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('relatedEvent', $event)"></div>
          <div class="content no-select label-text-2" @click="setSortOption('relatedEvents')">
            RELATED EVENT
            <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'relatedEvents'"></Icon>
            <Icon name="sort-up" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'relatedEvents' && this.pagingObj.sortReverse"></Icon>
            <Icon name="sort-down" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'relatedEvents' && !this.pagingObj.sortReverse"></Icon>
          </div>
        </div>
      </div>
    </div>
    <div class="ems-header-col"
          :style="{ width: columnWidth.recipients.size  ? (columnWidth.recipients.size + 'px') : '28%' }"
          id="recipients">
      <div class="header-container">
        <div class="crop">
          <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('recipients', $event)"></div>
          <div class="content no-select label-text-2" @click="setSortOption('recipients')" >
            RECIPIENTS
            <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'recipients'"></Icon>
            <Icon name="sort-up" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'recipients' && this.pagingObj.sortReverse"></Icon>
            <Icon name="sort-down" class="sort-icon"
                  v-if="this.pagingObj.sortType == 'recipients' && !this.pagingObj.sortReverse"></Icon>
          </div>
        </div>
      </div>
    </div>
    <div class="ems-header-col" :style="{ width: columnWidth.actions.size  ? (columnWidth.actions.size + 'px') : '14%' }"
          id="actions">
      <div class="header-container">
        <div class="crop">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/sort';
  import 'vue-awesome/icons/sort-up';
  import 'vue-awesome/icons/sort-down';
  import Icon from 'vue-awesome/components/Icon';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import * as _ from 'lodash';
  import consts from '@/_consts.js'

  export default {
    name: 'table-header',
    components: {
      Icon
    },
    props: {
    },
    data () {
      return {
        pagingObj: {
          sortType: '',
          sortReverse: false
        }
      }
    },
    computed: {
      ...mapGetters({
        columnWidth: 'GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES'
      })
    },
    methods: {
      setSortOption (sortType) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
        this.$bus.$emit('CHANGE_EMAIL_HISTORY_SORT', this.pagingObj);
      },
      changeColumnWidth: function (colName, mouseDownEvent) {
        this.resizing = true;
        let vueApp = this;
        // get current mouse position
        let shiftX = mouseDownEvent.clientX;
        // header width
        let dtHeaderEl = document.getElementById('dt-header');
        let headerWidth = dtHeaderEl.getBoundingClientRect().width;
        // get maximum width
        let maxLeft = this.columnWidth[colName].size ? this.columnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
        let newWidth = maxLeft;
        if (this.columnWidth.sentDate.size === 0) {
          consts.defaultColumnEmailHistories.forEach((element) => {
            let el = document.getElementById(element.colName);
            let elWidth = el.getBoundingClientRect().width;
            let objResize = {
              headerWidth: headerWidth,
              colName: element.colName,
              newWidth: elWidth
            };
            this.mutationSaveWidthTableEmailHitories(objResize);
          })
        }

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        let newHeaderWidth = 0;
        function onMouseMove (event) {
          // new position
          let bufferPx = event.clientX - shiftX;
          newHeaderWidth = headerWidth + bufferPx;

          if (bufferPx < 0 && (maxLeft - Math.abs(bufferPx)) < 20) {
            newWidth = 20;
            newHeaderWidth = headerWidth - (maxLeft - 20);
          } else {
            newWidth = maxLeft + bufferPx;
          }

          // save data
          vueApp.mutationSaveWidthTableEmailHitories({
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: colName,
            newWidth: newWidth.toFixed(2)
          });

          let dtHeaderEl = document.getElementById('dt-header');
          let dtBodyEl = document.getElementById('ems-table-body');
          dtHeaderEl.style.width = newHeaderWidth + 'px';
          dtBodyEl.style.width = newHeaderWidth + 'px';
        }

        function onMouseUp () {
          document.removeEventListener('mouseup', onMouseUp);
          document.removeEventListener('mousemove', onMouseMove);
          setTimeout(() => {
            vueApp.resizing = false;
          }, 50);
        }
      },
      saveDefaultColumnWidth (isWidthPercent) {
        let dtHeaderEl = document.getElementById('dt-header');
        let dtBodyEl = document.getElementById('ems-table-body');
        let headerWidth = dtHeaderEl.getBoundingClientRect().width;
        let newHeaderWidth = headerWidth < 1000 ? 1000 : headerWidth;

        if (isWidthPercent) {
          dtHeaderEl.style.width = 'unset';
          dtBodyEl.style.width = 'unset';
        } else {
          dtHeaderEl.style.width = '950px';
          dtBodyEl.style.width = '950px';
        }
        consts.defaultColumnEmailHistories.forEach((element) => {
          let objResize = {
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: element.colName,
            newWidth: isWidthPercent ? 0 : element.size,
            isWidthPercent: isWidthPercent
          };
          this.mutationSaveWidthTableEmailHitories(objResize);
        })
      },
      ...mapActions({
      }),
      ...mapMutations({
        mutationSaveWidthTableEmailHitories: 'MUTATION_SAVE_COLUMN_WIDTH_TABLE_EMAIL_HISTORIES'
      })
    },
    mounted () {
      if (document.body.clientWidth < 1000) {
        this.saveDefaultColumnWidth();
      }
    },
    created () {
      window.addEventListener('resize', _.debounce((event) => {
        if (document.body.clientWidth < 1000) {
          this.saveDefaultColumnWidth();
        } else {
          this.saveDefaultColumnWidth(true);
        }
      }, 100));
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// EmailHistoriesHeader.vue?d8067dd8